export default [
  {
    name: 'unit-archive-find',
    path: '/units/archive',
    component: () => import('@/views/units/archive/UnitArchiveFind')
  },
  {
    name: 'unit-un-archive',
    path: '/units/archives/:id/unarchive/edit',
    component: () => import('@/views/units/archive/UnitUnArchiveWizard')
  },
  {
    name: 'unit-archives-view',
    path: '/units/archives/:id/view',
    component: () => import('@/views/units/UnitManage')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnitsArchives.js